import React, {useState, useEffect} from 'react'

import pill from "./../../../UI/general/pill.svg"

interface SidebarMapProps {
  logoVias: string,
  logoPuntos: string,
  locationData: any,
  colorsData: any,
  handleFilteredRoute: any,
  handleSelectPOI: any
  POISActive: boolean,
  routesActive: boolean
}
declare const window: any;

const SidebarMapsMobile = ({logoVias, logoPuntos, locationData, colorsData, handleFilteredRoute, handleSelectPOI, routesActive, POISActive}: SidebarMapProps) => {

  const [isLocationBarHidden, setLocationBarHidden] = useState(false)
  const [isViasOpened, setViasOpened] = useState(false)
  const [isPOISOpened, setPOISOpened] = useState(false)
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(0)
  const [selectedPOIIndex, setSelectedPOIIndex] = useState(-1)

    useEffect(() => {
      (async () => {
          var svgObj: any = document.querySelector('#selected-poi')
          if(svgObj){
              await fetch(svgObj.data)
              .then((response => response.blob()))
              .then((data) => {
                  var url = URL.createObjectURL(data)
                  svgObj.data = url
                  svgObj.addEventListener('load', () => {
                      var svgDoc = svgObj.contentDocument
                      var paths = svgDoc.querySelectorAll('path')
                      paths.forEach((path: any) => {
                          path.setAttribute('fill',colorsData.secondary_text)
                      })
                      var defs = svgDoc.querySelectorAll('defs')
                      var svg = svgDoc.querySelector('svg')
                      if(defs.length > 0){
                          svg.removeChild(defs[0])
                      }

                  })
              })

          }
      })();
  }, [selectedRouteIndex, colorsData]);

  useEffect(() => {
      (async () => {
          var svgObj: any = document.querySelectorAll('#unselected-poi')
          if(svgObj){
              svgObj.forEach((obj: any) => {
                  var svgDoc = obj.contentDocument
                  var paths = svgDoc.querySelectorAll('path')
                  paths.forEach((path: any) => {
                      path.setAttribute('fill',colorsData.main_text)
                  })
              })
          }
      })();
  }, [selectedRouteIndex, colorsData]);

  return(
    <div className={isLocationBarHidden ? "location-bar-mobile-collapsed":"location-bar-mobile-opened"}>
      <div className='hidde-location-mobile-container' onClick = {() => {setLocationBarHidden(!isLocationBarHidden)}}>
        <img src={pill} alt=""></img>
      </div>
      {
        !isLocationBarHidden ? 
        <div className='options-location-btns-container'>
          <div
           className='options-lotacion-btn-mobile' 
          onClick={() => {setViasOpened(!isViasOpened); setPOISOpened(false)}}
          style={{
            backgroundColor: isViasOpened ? colorsData.main_buttons: '#fff',
            color: isViasOpened ? colorsData.secondary_text: '#000'
          }}
          >
            <img 
            src={logoVias} 
            alt=""
            style={{
              filter: isViasOpened ? 'invert(1) brightness(100%)': 'none',
            }}
            />
            <div>Vias de acceso</div>
          </div>
          <div 
          className='options-lotacion-btn-mobile' 
          onClick={() => {setPOISOpened(!isPOISOpened); setViasOpened(false)}}
          style={{
            backgroundColor: isPOISOpened ? colorsData.main_buttons: '#fff',
            color: isPOISOpened ? colorsData.secondary_text: '#000'
          }}
          >
            <img 
            src={logoPuntos} 
            alt=""
            style={{
              filter: isPOISOpened ? 'invert(1) brightness(100%)': 'none',
            }}
            />
            <div>Puntos de interés</div>
          </div>
        </div>:null
      }
      {
        !isLocationBarHidden && isViasOpened ?
        <div className='vias-location-container-mobile'>
          <div 
            className='individual-route-mobile' 
            style={{
                backgroundColor: selectedRouteIndex === 0 && routesActive ? colorsData.main_buttons :"transparent",
                transition: "all 0.3s ease-in-out"
            }}
            onClick = {() => {
                setSelectedRouteIndex(0)
                handleFilteredRoute("")
            }}
        >
            <div 
                className='individual-route-name-mobile'
                style = {{
                    color: selectedRouteIndex === 0 && routesActive ?  colorsData.secondary_text:colorsData.main_text
                }}
            >Ver Todas</div>
        </div>
          {
            locationData.routes.map((route: any, index: number) => 
              <div
                className='individual-route-mobile'
                key={route.name + index}  
                style={{
                    backgroundColor: selectedRouteIndex === index + 1 && routesActive ? colorsData.main_buttons : "transparent",
                    transition: "all 0.3s ease-in-out"
                }}
                onClick = {() => {
                    setSelectedRouteIndex(index + 1)
                    handleFilteredRoute(route.name)
                }}
              >
                <div className='color-route-container-mobile' style={{backgroundColor: route.color}}/>
                    <div 
                        className='individual-route-name-mobile'
                        style = {{
                            color: selectedRouteIndex === index + 1 && routesActive ?  colorsData.secondary_text:colorsData.main_text
                        }}
                        >{route.name}</div>
              </div>
            )
          }
        </div>:null
      }
      {
        !isLocationBarHidden && isPOISOpened ?
        <div className='vias-location-container-mobile-pois'>
          {
            locationData.POIS.map((POIS: any, index: number) => 
            <div 
              className='individual-route-mobile'
              key ={POIS.category + index}
              style={{
                  backgroundColor: selectedPOIIndex === index && POISActive ? colorsData.main_buttons :"transparent",
                  transition: "all 0.3s ease-in-out"
              }}
              onClick = {() => {
                  setSelectedPOIIndex(index)
                  handleSelectPOI(POIS)
              }}
          >
              {
                <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+POIS.icon.replace(' ', '+')} alt='' style={{filter:  selectedPOIIndex === index && POISActive ? 'invert(1) brightness(1) grayscale(1)':'none'}}/>
              }
              <div 
                  className='individual-poi-name-mobile'
                  style = {{
                      color: selectedPOIIndex === index && POISActive ?  colorsData.secondary_text:colorsData.main_text
                  }}
                  >{POIS.category}</div>
          </div>
            )
          }
        </div>:null
      }
    </div>
  )
}

export default SidebarMapsMobile